<template>
  <div data-scroll-name="details">
    <section class="my-30">
      <Container>
        <SectionHeader>Details</SectionHeader>
        <div>
          <div v-if="getDetails.description.value">
            <p
              class="text-justify leading-8 tracking-wide text-secondary-color"
            >
              {{ getDetails.description.value }}
            </p>
          </div>
          <div class="bg-[#F3F5FB] rounded-lg p-8 lg:p-12 mt-16 flex flex-wrap justify-center gap-6">
            <div
              v-for="(detail, index) in list"
              :key="index"
              class="flex flex-wrap gap-x-2 text-secondary-color bg-[#EBEEF6] py-2.5 px-4 rounded-lg"
            >
              <div class="font-bold">
                {{ detail.label }}:
              </div>
              <div>
                {{ detail.value }}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Container from "../../components/Container";
import SectionHeader from "../../components/SectionHeader";

export default {
  name: "Details",
  components: {
    Container,
    SectionHeader,
  },
  computed: {
    ...mapGetters("tour", ["getDetails", "getPrimaryColor"]),
    list() {
      return (
        Object.values(this.getDetails).filter(
          (detail) => detail.label !== "Description" && detail.label !== "Address"
        ) || []
      );
    },
  },
};
</script>
